import { produce } from 'immer';

import { StoreHelper } from '../storeHelper';

export interface LoadingState {
	isLoadingGetCaptcha: boolean;
	isLoadingSendMessage: boolean;
	isLoadingGetDocuments: boolean;
	isLoadingSimulation: boolean;
	isLoadingSimulationOverview: boolean;
	isLoadingInit: boolean;
	isLoadingQRCodeAndLink: boolean;
}

export const loadingInitialState: LoadingState = {
	isLoadingGetCaptcha: false,
	isLoadingSendMessage: false,
	isLoadingGetDocuments: false,
	isLoadingSimulation: false,
	// to show skeleton while fetching simulation overview from start app
	isLoadingSimulationOverview: true,
	// to show skeleton while fetching init from start app
	isLoadingInit: true,
	isLoadingQRCodeAndLink: false,
};

interface UseLoadingStoreOutput extends LoadingState {
	setIsLoadingGetCaptcha: (data: boolean) => void;
	setIsLoadingSendMessage: (data: boolean) => void;
	setIsLoadingGetDocuments: (data: boolean) => void;
	setIsLoadingSimulation: (data: boolean) => void;
	setIsLoadingSimulationOverview: (data: boolean) => void;
	setIsLoadingInit: (data: boolean) => void;
	setIsLoadingQRCodeAndLink: (data: boolean) => void;
}

export const useLoadingStore = StoreHelper.createStore<UseLoadingStoreOutput>(
	(set, get) => ({
		...loadingInitialState,
		setIsLoadingGetCaptcha: (isLoadingGetCaptcha: boolean) =>
			set(
				produce((state: LoadingState): LoadingState => {
					const innerState = get();

					return {
						...innerState,
						isLoadingGetCaptcha,
					};
				}),
				false,
				'@@CONSUMERLOANSPUBLIC/LOADING/setIsLoadingGetCaptcha'
			),
		setIsLoadingSendMessage: (isLoadingSendMessage: boolean) =>
			set(
				produce((state: LoadingState): LoadingState => {
					const innerState = get();

					return {
						...innerState,
						isLoadingSendMessage,
					};
				}),
				false,
				'@@CONSUMERLOANSPUBLIC/LOADING/setIsLoadingSendMessage'
			),
		setIsLoadingGetDocuments: (isLoadingGetDocuments: boolean) =>
			set(
				produce((state: LoadingState): LoadingState => {
					const innerState = get();

					return {
						...innerState,
						isLoadingGetDocuments,
					};
				}),
				false,
				'@@CONSUMERLOANSPUBLIC/LOADING/setIsLoadingGetDocuments'
			),
		setIsLoadingSimulation: (isLoadingSimulation: boolean) =>
			set(
				produce((state: LoadingState): LoadingState => {
					const innerState = get();

					return {
						...innerState,
						isLoadingSimulation,
					};
				}),
				false,
				'@@CONSUMERLOANSPUBLIC/LOADING/setIsLoadingSimulation'
			),
		setIsLoadingSimulationOverview: (isLoadingSimulationOverview: boolean) =>
			set(
				produce((state: LoadingState): LoadingState => {
					const innerState = get();

					return {
						...innerState,
						isLoadingSimulationOverview,
					};
				}),
				false,
				'@@CONSUMERLOANSPUBLIC/LOADING/setIsLoadingSimulationOverview'
			),
		setIsLoadingInit: (isLoadingInit: boolean) =>
			set(
				produce((state: LoadingState): LoadingState => {
					const innerState = get();

					return {
						...innerState,
						isLoadingInit,
					};
				}),
				false,
				'@@CONSUMERLOANSPUBLIC/LOADING/setIsLoadingInit'
			),
		setIsLoadingQRCodeAndLink: (isLoadingQRCodeAndLink: boolean) =>
			set(
				produce((state: LoadingState): LoadingState => {
					const innerState = get();

					return {
						...innerState,
						isLoadingQRCodeAndLink,
					};
				}),
				false,
				'@@CONSUMERLOANSPUBLIC/LOADING/setIsLoadingQRCodeAndLink'
			),
	}),
	'@@CONSUMERLOANSPUBLIC/LOADING/'
);
